import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
// import ScrollTrigger from 'react-scroll-trigger';
import { useInView } from 'react-intersection-observer';

// import Popup1099NEC from '@/components/ui/1099PopupNec';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const FormW8BEN = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Now Accepting <span style="color:#1da94a; font-weight: 600;">Form 1098-E</span> for Tax Year 2024!`,
  //   SubHeading: 'File your student loan interest deductions with ease.  ',
  //   CtaText: ' Get Started Today!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098e`,
  //   isActive: true,
  // };

  // const [visible, setVisible] = useState(false);

  // const onEnterViewport = () => {
  //   setVisible(true);
  // };

  // const onExitViewport = () => {
  //   setVisible(false);
  // };
  const [visible, setVisible] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false, // change to true if you only want to animate once
  });

  useEffect(() => {
    setVisible(inView);
  }, [inView]);

  // const { ref, inView } = useInView({
  //   threshold: 0.2,
  //   triggerOnce: true,
  // });
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Free Form W-8BEN Online | TaxZerone"
          description="Easily request Form W-8BEN online at no cost with TaxZerone. Fast, secure, and 100% free for non-U.S. individuals to claim tax treaty benefits with ease."
          keywords=""
          canonical="request-form-w8ben-online-free/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg=""
        />
      }
    >
      {/* <Popup1098E /> */}

      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Today&apos;s the Final Day to E-file Form 1099-NEC!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Time is running out! Make sure you file your <b>Form 1099-NEC</b>{' '}
              for non-employee compensation today, <b>January 31st</b>.
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            backgroundColor: '#2f3e46',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Typography
                component={'div'}
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                  color: '#fff',
                  lineHeight: 1.3,
                }}
              >
                File your{' '}
                <strong>
                  Form 1098-E
                  <small style={{ fontWeight: 500, color: '#fff' }}></small>
                </strong>{' '}
                for the Tax Year 2024{' '}
                <b style={{ fontWeight: 600, color: '#fff' }}>with TaxZerone</b>
              </Typography>
              <Typography
                component={'div'}
                variant="body2"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 13, sm: 15, md: 16, lg: '1.20rem' },
                  color: '#fff',
                  lineHeight: 1.3,
                  mt: 0.5,
                }}
              >
                Easily report student loan interest to the IRS.
              </Typography>
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098e`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Start filing now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component={'section'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Request Free{' '}
                <span className="highlight-container">
                  <span className="highlight">Form W-8BEN</span>
                </span>{' '}
                Online
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Easily request your client’s{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Certificate of Foreign Status
                </span>{' '}
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                (Form W-8BEN) with TaxZerone. Perfect for non-U.S. freelancers,
                investors, and international individuals earning U.S. income.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw8ben`}
                  >
                    Request W-8BEN Form
                    {/* → */}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      1099-NEC
                    </Box> */}
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w8ben-landing-img.webp" />
                <source srcSet="/assets/images/w8ben-landing-img.png" />
                <img
                  src="/assets/images/w8ben-landing-img.png"
                  alt="Request Free Form W-8BEN Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w8ben-landing-img-sm.webp" />
                <source srcSet="/assets/images/w8ben-landing-img-sm.png" />
                <img
                  src="/assets/images/w8ben-landing-img-sm.png"
                  alt="Request Free Form W-8BEN Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 34, sm: 26, xs: 22 },
                fontWeight: 500,
                mb: 0,
                textAlign: 'center',
                lineHeight: 1.5,

                /* HTML: <div class="ribbon">Your text content</div> */

                // --r: '.8em ',

                // borderInline: '.5em solid #0000',
                // padding: '.5em .2em calc(var(--r) + .2em)',
                // clipPath: 'polygon(0 0,100% 0,100% 100%,calc(100% - .5em) calc(100% - var(--r)),50% 100%,.5em calc(100% - var(--r)),0 100%)',
                // background: 'radial-gradient(50% .2em at top,#000a,#0000)',
                //  borderBox: '#bd1550 padding-box', /* the color  */
                // width: 'fit-content',
              }}
            >
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 24, sm: 30 },
                }}
              >
                100% Free
              </Box>{' '}
              —Forever
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
              No subscriptions.{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#f3f3f3',
                mb: 1,
                textAlign: 'center',
              }}
            >
              You can request unlimited W-8BEN forms completely free, anytime
              you need.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Whether you&apos;re an individual or business, our platform is
              built to save you time—and money—without compromising quality.
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              // maxWidth: { xs: '100', sm: 250, md: 280 },
              textAlign: 'center',
              fontSize: 18,
              lineHeight: 1.2,
            }}
          >
            <Button
              size="large"
              variant="contained"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw8ben`}
              sx={{
                boxShadow: 'none',
                borderRadius: 2,
                mb: 0.5,
                textTransform: 'none',
                backgroundColor: '#fff',
                color: '#0a7581',
                '&:hover, &:focus, &:active': {
                  color: '#fff',
                  backgroundColor: '#172b6b',
                },
              }}
            >
              Get Started Now
            </Button>
            {/* <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography> */}
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to Request W-8BEN Form Online Using TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow the easy steps to send Authorization of Reporting Agent
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/w-8ben-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/w-8ben-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/w-8ben-steps-img.png"
                  alt="How to Request W-8BEN Form Online Using TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Timeline
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt=" Invite the Recipient"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Invite the Recipient
                    </Typography>
                    <Typography variant="body1">
                      Enter the recipient’s name and email address to send an
                      invitation to fill out the W-8BEN form.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Recipient Fills & Signs"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Recipient Fills & Signs
                    </Typography>
                    <Typography variant="body1">
                      The recipient completes their information and
                      electronically signs the form.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Download & Save"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Download & Save
                    </Typography>
                    <Typography variant="body1">
                      Download the completed form instantly and print it for
                      your records or share it with your payer.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Timeline>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw8ben`}
                >
                  Request W-8BEN
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component={'section'}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for W-8BEN Requests Online?
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="World Global Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  World Global Support
                </Typography>
                <Typography variant="body1">
                  TaxZerone helps you complete the form accurately with the
                  right treaty benefits, no matter where you are.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Secure Portal"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Secure Portal
                </Typography>
                <Typography variant="body1">
                  Your clients can easily submit and access their W-8BEN forms
                  through <span style={{ fontWeight: 600 }}> ZeroneVault</span>,
                  our secure platform designed to keep their data safe.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/download-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/download-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/download-icon.png"
                      alt="Download & Print Anytime"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Download & Print Anytime
                </Typography>
                <Typography variant="body1">
                  Easily access, download, and print your completed forms
                  whenever you need them - no waiting, no restrictions.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="IRS Compliant"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Compliant
                </Typography>
                <Typography variant="body1">
                  Our forms are 100% IRS-compliant and updated with the latest
                  tax regulations and requirements.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mobile-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mobile-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mobile-icon.png"
                      alt="Mobile Friendly "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Mobile Friendly
                </Typography>
                <Typography variant="body1">
                  Request forms on any device - desktop, tablet, or mobile.
                  Works seamlessly everywhere.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Expert Guidance"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Guidance
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}> Have any questions?</span>{' '}
                  Our support team is here to help with expert guidance whenever
                  you need it.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={12} sx={{ textAlign: 'center', mt: 8 }}>
              <Box>
                <Typography variant="body1">
                  Choose TaxZerone for a simplified, secure, and accurate form w
                  8ben request process.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw8ben`}
                >
                  Get Started Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Trusted by Thousands
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  fontSize: { md: 18, sm: 16, xs: 15 },
                  textAlign: 'center',
                }}
              >
                Join thousands of satisfied users who have simplified their tax
                compliance with TaxZerone.{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} m={2}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#cddafd',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={50}
                      duration={2}
                      suffix="K+"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Forms Generated'
                  )}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Forms Generated
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#cddafd',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={99.9}
                      duration={2}
                      decimal="."
                      decimals={1}
                      suffix="%"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Success Rate '
                  )}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Success Rate
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#cddafd',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={150}
                      duration={2}
                      suffix="+"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Countries Supported '
                  )}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Countries Supported
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#cddafd',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <CountUp
                      end={24}
                      duration={2}
                      suffix="/7"
                      style={{
                        fontWeight: 600,
                        fontSize: 44,
                      }}
                    />
                  ) : (
                    'Email Support Available '
                  )}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mt: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Email Support Available
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          background: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component={'section'}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                What Our Users Say
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  mb: { xs: 1, sm: 3 },
                }}
              >
                Join thousands of satisfied users from around the world who have
                simplified their tax compliance with TaxZerone.
              </Typography>

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Honestly shocked at how fast it was. I highly recommend
                        TaxZerone for anyone needing to request the W-8BEN form.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right', mt: 4 }}
                    >
                      - Sarah Mitchell, UK
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        As a freelancer outside the U.S., I needed a fast way to
                        submit my w 8ben. TaxZerone made it simple and easy.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right', mt: 4 }}
                    >
                      - Maria Santos, Philippines
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I love that real people are behind the chat, not bots. I
                        felt heard and supported. I got my form submitted the
                        same day.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Lucas Silva, Brazil
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component={'section'}
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to Request Form W-8BEN Online?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          TaxZerone makes the process simple and stress-free.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw8ben`}
          >
            Create a Free Account
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg" component={'section'} aria-labelledby="w8ben-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2" id="w8ben-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is Form W-8BEN?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Form W-8BEN,{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Certificate of Foreign Status of Beneficial Owner for
                        United States Tax Withholding and Reporting
                        (Individuals)
                      </span>
                      , is used by foreign individuals to certify their non-U.S.
                      status. This IRS form allows them to claim reduced
                      withholding rates or exemptions under applicable tax
                      treaties. It helps prevent the standard 30% withholding on
                      U.S. source income.
                    </Typography>
                    <Typography variant="body1">
                      U.S. persons use the{' '}
                      <Link
                        href="/request-form-w9-online-free/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        W-9 form{' '}
                      </Link>
                      for similar tax reporting purposes.{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Where do I send Form W-8BEN?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Do NOT send Form W-8BEN to the IRS
                      </span>
                      . Instead, provide it directly to:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        The withholding agent (the person or entity paying you
                        income){' '}
                      </li>
                      <li>Your bank, broker, or financial institution </li>
                      <li>The partnership allocating income to you </li>
                      <li>
                        Any Foreign Financial Institution (FFI) requesting it
                        for account documentation{' '}
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The form should be given to whoever is requesting it from
                      you, typically before any payment is made to you or
                      credited to your account.{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who needs to fill out Form W-8BEN?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >

                  <Typography itemProp="text" variant="body1" sx={{ mt: 1, mb: 0 }}>
                    Nonresident alien individuals who are beneficial owners of
                    U.S. source income must complete Form W-8BEN. This
                    includes foreign persons receiving dividends, interest,
                    rents, royalties, or other FDAP income. Account holders at
                    foreign financial institutions and foreign partners in
                    U.S. partnerships also need this form.
                  </Typography>

                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What types of U.S. income are subject to 30% withholding
                  tax for foreign persons?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant='body1' sx={{ mt: 1, mb: 0 }}>
                      Foreign individuals generally have 30% U.S. tax withheld
                      on certain types of income from U.S. sources. This
                      includes
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        Interest (including certain original issue discount
                        (OID)){' '}
                      </li>
                      <li>Dividends </li>
                      <li>Rents </li>
                      <li>Royalties </li>
                      <li>Premiums </li>
                      <li>Annuities </li>
                      <li>
                        Compensation for, or in expectation of, services
                        performed;{' '}
                      </li>
                      <li>
                        Substitute payments in a securities lending transaction;
                        or{' '}
                      </li>
                      <li>
                        Other fixed or determinable annual or periodical gains,
                        profits, or income.{' '}
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What income types require Form W-8BEN to avoid backup
                  withholding?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant='body1' sx={{ mt: 1, mb: 1 }}>
                      <span style={{ fontWeight: 600 }}> Form W-8BEN</span> to
                      claim an exception from{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        U.S. domestic information reporting and backup
                        withholding (under section 3406)
                      </span>{' '}
                      for certain types of income that are{' '}
                      <span style={{ fontWeight: 600 }}>
                        not subject to the standard 30% withholding rate under
                        section 1441.
                      </span>{' '}
                      Examples of such income include:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Broker proceeds -
                        </span>{' '}
                        Income from securities transactions{' '}
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Short-term OID -
                        </span>{' '}
                        Original Issue Discount for 183 days or less
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Foreign source income -
                        </span>{' '}
                        Interest, dividends, rents, or royalties from foreign
                        sources
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Gaming proceeds -
                        </span>{' '}
                        Winnings from blackjack, baccarat, craps, roulette, or
                        big-6 wheel; and
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Transportation income -
                        </span>{' '}
                        U.S. source gross transportation income, as defined in
                        section 887(b)(1), that are taxable under section
                        887(a).
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. How long does my W-8BEN form stay valid?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant='body1' sx={{ mt: 1, mb: 1 }}>
                      Your W-8BEN form remains valid for{' '}
                      <span style={{ fontWeight: 600 }}> 3 years</span> from the
                      signing date.
                    </Typography>
                    <Typography variant="body1">
                      <span style={{ fontWeight: 600, fontStyle: 'italic' }}>
                        For example
                      </span>
                      , if signed on September 30, 2024, it remains valid
                      through December 31, 2027. However, if your circumstances
                      change—like moving to the U.S. or changing tax
                      residency—you must submit a new form within 30 days of the
                      change.{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. What&apos;s the difference between lines 6a and 6b, and do
                  I need to fill them out?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}> Line 6a:</span> This
                        is where you provide your{' '}
                        <span style={{ fontWeight: 600 }}>
                          Foreign Tax Identifying Number
                        </span>
                        (FTIN) - essentially your tax ID number from your home
                        country.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}> Line 6b:</span> This
                        is a checkbox you use instead of line 6a if you
                        don&apos;t have an FTIN and aren&apos;t legally required
                        to get one.
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      Do you need to fill them out?{' '}
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Use Line 6a if:
                        </span>{' '}
                        You have a tax ID number from your home country
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Use Line 6b if:
                        </span>
                      </li>
                      <ul>
                        <li>
                          Your country doesn&apos;t issue tax ID numbers,
                          OR{' '}
                        </li>
                        <li>
                          You&apos;re not legally required to have one in your
                          country{' '}
                        </li>
                      </ul>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Skip both if:
                        </span>{' '}
                      </li>
                      <ul>
                        <li>You&apos;re a U.S. territory resident, OR </li>
                        <li>
                          Your country is on the IRS list of jurisdictions that
                          don&apos;t issue foreign TINs
                        </li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box component={'article'}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  8. What is the difference between Form W-8BEN and Form W-9?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <TableContainer itemProp="text" sx={{ border: '1px solid #828282', mt: 1, mb: 1 }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                            }}
                          >
                            Aspect
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                            }}
                          >
                            Form W-8BEN
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                            }}
                          >
                            Form W-9
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Who Should Use It{' '}
                          </TableCell>
                          <TableCell>
                            Non-U.S. individuals (foreign persons) receiving
                            income from U.S. sources
                          </TableCell>

                          <TableCell>
                            U.S. citizens, U.S. residents, and domestic
                            entities
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Main Purpose{' '}
                          </TableCell>
                          <TableCell>
                            To certify foreign status and claim tax treaty
                            benefits (if applicable){' '}
                          </TableCell>

                          <TableCell>
                            To provide a Taxpayer Identification Number
                            (TIN) to requesters for tax reporting{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Used For{' '}
                          </TableCell>
                          <TableCell>
                            Reducing or eliminating U.S. tax withholding on
                            certain U.S.-sourced income{' '}
                          </TableCell>

                          <TableCell>
                            Reporting payments like freelance work,
                            interest, or dividends via Form 1099
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Type of Taxpayer{' '}
                          </TableCell>
                          <TableCell>
                            Provided to the U.S. company; not filed with the
                            IRS
                          </TableCell>

                          <TableCell>
                            Provided to the U.S. company or requester; not
                            submitted to the IRS
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Tax Withholding{' '}
                          </TableCell>
                          <TableCell>
                            30% withholding may apply unless a tax treaty
                            benefit is claimed
                          </TableCell>

                          <TableCell>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              No withholding
                            </span>{' '}
                            if correct TIN is provided;{' '}
                            <span style={{ fontWeight: 600 }}>
                              24% backup withholding if TIN
                            </span>{' '}
                            is missing or incorrect
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW8BEN;
